document.addEventListener("DOMContentLoaded", function () {
    jQuery(".saana-gallery__main-gallery").slick({
        dots: true,
        dotsClass: "gallery__carousel_dots slick--dots",
        centerMode: true,
        mobileFirst: true,
        fade: true,
        prevArrow:
            '<button type="button" class="slick-prev"><span class="dashicons dashicons-arrow-left-alt2"></span></button>',
        nextArrow:
            '<button type="button" class="slick-next"><span class="dashicons dashicons-arrow-right-alt2"></span></button>',
        adaptiveHeight: true,
    });
    jQuery(".slick--dots button").empty();
});

jQuery(".saana-gallery__main-gallery").on("init", (event, slick) => {
    jQuery(".gallery__carousel_dots button").empty();
});

jQuery(".saana-gallery__main-gallery").on(
    "beforeChange",
    (event, slick, currentSlide, nextSlide) => {
        const targetGallery = jQuery(event.target).parent().parent();
        const bono = "#slide-info-" + nextSlide;
        targetGallery.find(".slide-active").removeClass("slide-active");
        targetGallery.find(bono).addClass("slide-active");
    }
);
